import Vue from 'vue'
import Intersect from 'intersection-observer'

Vue.use(Intersect)
